import { bindProgressToVideo, VideoWithProgress } from '~/pages/helpers';
import { CaseStudy, CaseStudyPassedResult, LearningModule } from '~/types';
import assertNever from '~/utils/errors/assertNever';
import { VideoProgressData } from '~/utils/videoProgressUtils';

export interface CaseStudyWithProgress extends CaseStudy {
  passed?: boolean;
}

export type LearningModuleWithProgress = CaseStudyWithProgress | VideoWithProgress;

const bindProgressToCaseStudy = (
  attempts: CaseStudyPassedResult[],
  study: CaseStudy,
): CaseStudyWithProgress => {
  const successAttempts = attempts.filter(
    (attempt) => Number(attempt?.case_study_id) === Number(study?.id) && attempt.passed,
  );
  const failedAttempts = attempts.filter(
    (attempt) => Number(attempt?.case_study_id) === Number(study?.id) && !attempt.passed,
  );
  const passed = successAttempts.length ? true : failedAttempts.length ? false : undefined;
  return {
    ...study,
    passed,
  };
};

const bindProgressToLearningModule =
  ({
    caseStudyAttempts,
    progressDataByVideoId,
    watchlistById,
  }: {
    caseStudyAttempts?: CaseStudyPassedResult[];
    progressDataByVideoId?: Record<string, VideoProgressData>;
    watchlistById?: Record<string, boolean>;
  }) =>
  (module: LearningModule) => {
    switch (module.__typename) {
      case 'Video':
        return bindProgressToVideo(progressDataByVideoId, watchlistById)(module);
      case 'CaseStudy':
        return caseStudyAttempts ? bindProgressToCaseStudy(caseStudyAttempts, module) : module;
      case null:
      case undefined:
        return null;
      default:
        assertNever(module);
    }
  };

export default bindProgressToLearningModule;
